'use strict';

/* Dependencies */

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var React = require('react/addons');
var classSet = React.addons.classSet;

/* Stores */
var ColorStore = require('stores/color');

/* Components */
var UserDetails = React.createClass({
  displayName: 'UserDetails',

  render: function render() {
    var props = this.props;
    var _makeInitials = this._makeInitials;
    var user = props.user;
    var children = props.children;

    user = user || children;

    // Make initials
    var initials = _makeInitials(user.name);

    // Get user color
    var userColorNumber = user.color;
    var colorNumber = userColorNumber % ColorStore.colors.length;
    var color = ColorStore.colors[colorNumber];

    var lightness = [].concat(_toConsumableArray({ length: 3 })).map(function (_, i) {
      return Number('0x' + color[i * 2 + 1] + color[i * 2 + 2]);
    }).reduce(function (prev, curr) {
      return prev + curr;
    }) / 3 / 0xFF;

    var lightText = lightness < 0.5;

    var classes = { "initials-component": true };

    var style = {
      color: color,
      border: 'solid 1px ' + color
    };

    if (user.apiToken) {
      initials = 'API';

      style = {
        color: '#aaa',
        border: 'solid 1px #aaa'
      };
    }

    return React.createElement(
      'span',
      { className: classSet(classes), style: style },
      initials
    );
  },

  /*
   * Returns the first letter of the first and last
   * part of the name. (Ex. Martin Daniel Kolpak = MK)
   */
  _makeInitials: function _makeInitials(name) {
    return name

    // Divide into words
    .split(' ')

    // Only take the first and last work
    .filter(function (word, index, array) {
      return index === 0 || index === array.length - 1;
    })

    // Take the first character in each work
    .map(function (word) {
      return word[0];
    })

    // Turn back into a string but without spaces
    .join('')

    // Make it uppercase (could be pure CSS with text-transform: uppercase)
    .toUpperCase();
  }
});

module.exports = UserDetails;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/user/initials.js
 **/